/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-restricted-globals */
import ForgotPasswordModalStepThree from '@brands/Auth/ForgotPasswordModals/ForgotPasswordModalStepThree';
import Sidenav from '@brands/Dashboard/Sidenav/Sidenav';
import { getUserByHash, HashedUser } from '@brands/services/auth/getUserByHash';
import { login, LoginResponse } from '@brands/services/auth/login';
import { signup } from '@brands/services/auth/signup';
import { isStartableCaseType } from '@brands/services/cases/retiredCaseTypes';
import { yupResolver } from '@hookform/resolvers/yup';
import Cookies from 'js-cookie';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';

import Button from '../../Components/Button/Button';
import TextField from '../../Components/Inputs/MuiTextField/TextField';
import PWDRequisite from '../../Components/PasswordValidation/PasswordValidation';
import { config } from '../../config/config';
import { useLocalStorageState, useStepUrl } from '../../hooks';
import { useClientBrandingFromUrl } from '../../hooks/useClientBrandingFromUrl';
import { InviteModalPayload, usePostAuth } from '../../hooks/usePostAuth';
import { AddAddressParams, UpdateBasicInfoParams } from '../../services/auth/signup';
import { createProviderProfile } from '../../services/identity/createProviderProfile';
import { getCurrentProfile } from '../../services/identity/getCurrentProfile';
import { saveCareAdvisorProfile } from '../../services/identity/saveCareAdvisorProfile';
import { saveProviderProfile } from '../../services/identity/saveProviderProfile';
import { ProviderProfile, UserRoleName } from '../../services/identity/types/UserProfile';
import { resolveInvite } from '../../services/patient_plan/services';
import { displayErrorDetails, displayDuplicateClientError } from '../../Utils/displayError';
import { cookieOptions } from '../../Utils/getToken';
import { hasCapsLetter, hasNumber, hasSpecialChar } from '../../Utils/validation';
import { INVITE_TOKEN_KEY, inviteReasonToHuman } from '../assets/helpers';
import ConfirmOTP from '../ConfirmOTP/ConfirmOTP';
import ForgotPasswordModalConfirmation from '../ForgotPasswordModals/ForgotPasswordModalConfirmation';
import ForgotPasswordModalStepOne from '../ForgotPasswordModals/ForgotPasswordModalStepOne';
import CompleteProfile from './CompleteProfile';
import styles from './styles.module.scss';
import { UserCompleteProfileForm } from './types';
import { UserSubmitForm, validationSchema } from './utils/validationSchema';

type AuthJWT = { isAuthenticated: boolean };
type ForgotPasswordCredentials = {
  username?: string;
  code: string;
  new_password: string;
  password?: string;
  reset_password_hash?: string;
};

const PLAN_ROUTE = '/Patient/my-plan';

const SignUp: FC = () => {
  const username = useMemo(() => uuidv4(), []);
  const { triggerPostAuth } = usePostAuth();

  const [email, setEmail] = React.useState<UserSubmitForm>({ email: '' });
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState<UserSubmitForm>({
    phoneNumber: '',
  } as any);
  const [passwordStr, setPasswordStr] = useState('');
  const [enteredD1Code, setEnteredD1Code] = useState<string | null>(null);
  const [completeProfileModal, setcompleteProfileModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [, setAuthJWT] = useLocalStorageState<AuthJWT>('isAuthenticated', {
    isAuthenticated: false,
  });
  const [forgotPasswordStep, setForgotPasswordStep] = useState(0);
  const [invitedUser, setInvitedUser] = useState<HashedUser | null>(null);
  const [defaultUser, setDefaultUser] = useState<{ email: string } | null>(null);
  const [checks, setChecks] = useState({
    capsLetterCheck: false,
    numberCheck: false,
    pwdLengthCheck: false,
    specialFlag: false,
  });
  const [searchParams] = useSearchParams();
  const { clientCode } = useParams<{ clientCode: string }>();
  useClientBrandingFromUrl(clientCode);
  const hash = searchParams.get('hash');
  const client = clientCode || searchParams.get('client');
  const external_user_id = searchParams.get('external_user_id');
  const [credentials, setCredentials] = useState<ForgotPasswordCredentials>({
    username: '',
    code: '',
    new_password: '',
  });
  const navigate = useNavigate();

  // Normalize the old ?client= querystring convention onto the path-based
  // /{clientCode}/sign-up URL, so existing bookmarked/shared links keep working.
  useEffect(() => {
    if (clientCode) return;
    const clientFromQuery = searchParams.get('client');
    if (!clientFromQuery) return;

    const params = new URLSearchParams(searchParams);
    params.delete('client');
    navigate(`/${clientFromQuery}/sign-up${params.toString() ? `?${params.toString()}` : ''}`, { replace: true });
  }, [clientCode, searchParams, navigate]);

  const mountedRef = useRef(true);

  // Reflect the active sign-up step as a unique URL so analytics can track
  // drop-offs per step. Mirrors the render conditions below.
  let signUpStep: string | null = null;
  if (otpModal && email.email) {
    signUpStep = 'verify';
  } else if (completeProfileModal && email.email) {
    signUpStep = 'profile';
  }
  useStepUrl('sign-up', signUpStep);
  // Role-specific extras captured on the first-launch profile form that are not
  // accepted by /auth/signup (Provider: education/specialties/credentials/biography,
  // CareAdvisor: biography). Persisted via authenticated endpoints right after login.
  const roleExtrasRef = useRef<{
    role?: string;
    education?: string[];
    specialty?: string[];
    additional_credentials?: string;
    biography?: string;
  } | null>(null);
  // Mirror the SignIn "skip dashboard" behavior on registration: when the
  // sign-up URL carries a `start_case`, persist the intent so PrivateRoutes
  // drops the patient straight into that case-type intake right after they
  // finish signing up, instead of landing them on the dashboard.
  const intakeIntent = useMemo(() => {
    const raw = searchParams.get('start_case');
    // Only honor a `start_case` naming a case type patients can still start:
    // arbitrary URL values never reach sessionStorage or the intake form, and
    // neither do retired types that are technically still in the enum.
    const caseType = isStartableCaseType(raw) ? raw : null;
    if (!caseType) return null;
    return { caseType, source: 'marketing' };
  }, [searchParams]);

  useEffect(() => {
    if (intakeIntent) {
      sessionStorage.setItem('intakeIntent', JSON.stringify(intakeIntent));
    }
  }, [intakeIntent]);

  const [inviteResult, setInviteResult] = useState<InviteModalPayload | null>(null);

  const inviteEffectRanRef = useRef(false);
  const seenToastsRef = useRef<Set<string>>(new Set());
  // Single in-flight guard for the signup POST. This is the shared chokepoint
  // both CompleteProfile form variants call, so it blocks a duplicate
  // POST /auth/signup (the source of duplicate Customer.io signup events) even
  // if a rapid double-submit slips past the buttons' `disabled` state or the
  // rendered form variant swaps mid-request. Synchronous, so it engages before
  // any re-render.
  const isSigningUpRef = useRef(false);

  const toastOnce = useCallback((key: string, fn: (msg: string) => void, msg: string) => {
    if (seenToastsRef.current.has(key)) return;
    seenToastsRef.current.add(key);
    fn(msg);
  }, []);

  const toastInfoOnce = (key: string, msg: string): void => toastOnce(key, toast.info, msg);
  const toastErrorOnce = (key: string, msg: string): void => toastOnce(key, toast.error, msg);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    clearErrors,
    setError,
    watch,
  } = useForm<UserSubmitForm>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema(setPhoneNumber, setEmail, hash)),
  });

  const watchPassword = watch('password');
  const watchConfirm = watch('confirmPassword');

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const setSafeLoading = useCallback((v: boolean) => {
    if (mountedRef.current) setLoading(v);
  }, []);

  const hardSignOut = (): void => {
    try {
      Cookies.remove('jwtToken', cookieOptions());
      Cookies.remove('refreshToken', cookieOptions());
      Cookies.remove('jwtTokenExpire', cookieOptions());
    } catch {
      /* noop */
    }
    try {
      localStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('isAuthenticated');
    } catch {
      /* noop */
    }
    setAuthJWT({ isAuthenticated: false });
  };

  const showJoinedToast = (): void => {
    const toastId = toast.success(
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ fontSize: 14, color: '#1E4620' }}>
          <span>You’ve successfully joined the plan.</span>
          <button
            type="button"
            onClick={() => {
              navigate(PLAN_ROUTE);
              if (toastId !== undefined) toast.dismiss(toastId);
            }}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              textDecoration: 'underline',
              cursor: 'pointer',
              paddingLeft: '5px',
              color: '#1E4620',
            }}
          >
            View plan.
          </button>
        </div>
      </div>,
      { closeOnClick: false, autoClose: 6000 },
    );
  };

  const triggerLogin = async (response: LoginResponse): Promise<void> => {
    await triggerPostAuth(response, {
      event: 'login',
      preloadPricingForPatient: true,
      suspendNavigationIfInvite: true,
      onInviteResult: (payload) => {
        if (payload.status === 'JOINED') {
          sessionStorage.removeItem('authSuspend');
          sessionStorage.removeItem('inviteResult');
          showJoinedToast();
          return;
        }
        setInviteResult(payload);
        sessionStorage.setItem('authSuspend', '1');
        sessionStorage.setItem('inviteResult', JSON.stringify(payload));
      },
    });
  };

  useEffect(() => {
    const authSuspend = sessionStorage.getItem('authSuspend') === '1';
    if (authSuspend) {
      const raw = sessionStorage.getItem('inviteResult');
      if (raw) {
        try {
          const parsed: InviteModalPayload = JSON.parse(raw);
          setInviteResult(parsed);
        } catch {
          /* noop */
        }
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      const emailParam = searchParams.get('email');

      if (hash) {
        await getUserByHash(hash)
          .then((response) => {
            setInvitedUser(response);
            setValue('email', response.email);
            setValue('phoneNumber', response.phone_number as any);
          })
          .catch((error) => {
            if (error.response && error.response.data.message.includes('Invitation hash is expired')) {
              const url = `/?email=${encodeURIComponent(error.response.data.email)}`;
              navigate(url);
            } else {
              displayErrorDetails(error);
            }
          });
      }

      if (emailParam) {
        const correctedEmail = emailParam.trim().replace(/\s/g, '+');
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const emailValid = emailRegex.test(correctedEmail);
        if (emailValid) {
          setValue('email', correctedEmail);
          setDefaultUser({ email: correctedEmail });
        }
      }
    })();
  }, [hash, searchParams, setValue]);

  useEffect(() => {
    (async (): Promise<void> => {
      if (inviteEffectRanRef.current) return;
      inviteEffectRanRef.current = true;

      const rawHref = typeof window !== 'undefined' ? window.location.href : '';
      const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');

      if (params.get('invite')) {
        const token = params.get('invite') as string;
        localStorage.setItem(INVITE_TOKEN_KEY, token);

        try {
          const meta = await resolveInvite(token);

          if (meta?.ok) {
            toastInfoOnce(`invite:${token}:ok`, 'You’re almost there—log in or sign up to join this plan.');
          } else {
            toastErrorOnce(`invite:${token}:reason:${meta?.reason ?? 'unknown'}`, inviteReasonToHuman(meta?.reason));
            localStorage.removeItem(INVITE_TOKEN_KEY);
          }
        } catch (err) {
          toastErrorOnce(`invite:${token}:invalid`, 'This invite link is invalid or expired.');
          localStorage.removeItem(INVITE_TOKEN_KEY);
        } finally {
          try {
            const url = new URL(rawHref);
            url.searchParams.delete('invite');
            window.history.replaceState({}, '', url.toString());
          } catch {
            /* noop */
          }
        }
      } else {
        localStorage.removeItem(INVITE_TOKEN_KEY);
      }
    })();
  }, []);

  const formatDateOfBirth = (dob: string): string => {
    const parsedDate = new Date(dob);
    if (isNaN(parsedDate.getTime())) return '';
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const renderForgotPasswordModal = (): JSX.Element | null => {
    switch (forgotPasswordStep) {
      case 1:
        return (
          <ForgotPasswordModalStepOne
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            credentials={credentials}
            setCredentials={setCredentials}
          />
        );
      case 3:
        return (
          <ForgotPasswordModalStepThree
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            credentials={credentials}
            setCredentials={setCredentials}
            resetFlag={false}
            triggerLogin={triggerLogin}
          />
        );
      case 5:
        return (
          <ForgotPasswordModalConfirmation
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            credentials={credentials}
            setCredentials={setCredentials}
          />
        );
      default:
        return null;
    }
  };

  const signUp = async (data: UserCompleteProfileForm): Promise<void> => {
    if (isSigningUpRef.current) return;
    isSigningUpRef.current = true;
    setSafeLoading(true);
    try {
      const profile: UpdateBasicInfoParams = {
        first_name: data.first_name,
        middle_name: data.middle_name,
        last_name: data.last_name,
        preferred_name: data.preferred_name || '',
        gender: data.gender,
        gender_identity: data.gender_identity,
        date_of_birth: formatDateOfBirth(data.date_of_birth),
        pronouns: data.pronouns || '',
        languages: (data.language as string[]) || [],
      };

      const address: AddAddressParams = {
        address1: data.address1,
        address2: data.address2 || '',
        city: data.city,
        state: data.state,
        zip_code: data.zip_code,
      };

      if (data.d1Code) {
        setEnteredD1Code(data.d1Code);
      }

      const role = invitedUser?.role?.name;
      if (role === UserRoleName.Provider) {
        roleExtrasRef.current = {
          role,
          education: data.education || [],
          specialty: (data.specialty || []).map((s) => s.value),
          additional_credentials: data.additional_credentials || '',
          biography: data.biography || '',
        };
      } else if (role === UserRoleName.CareAdvisor) {
        roleExtrasRef.current = { role, biography: data.biography || '' };
      } else {
        roleExtrasRef.current = null;
      }

      await signup({
        username,
        email: getValues('email')?.toLowerCase() || '',
        password: getValues('password') || '',
        attributes: {
          email: getValues('email')?.toLowerCase() || '',
          phone_number: getValues('phoneNumber') as any,
        },
        validation_data: {
          organization_id: config.organization_id,
          ...(client && { client }),
          ...(external_user_id && { external_user_id }),
          ...(data.d1Code && { access_code: data.d1Code }),
          ...(config.division_id && { division_id: config.division_id }),
          ...(config.practice_id && { practice_id: config.practice_id }),
          invitation_hash: hash || '',
        },
        phone_number: (data as any).phone_number || '',
        profile,
        address,
      });

      if (!mountedRef.current) return;
      setcompleteProfileModal(false);
      setOtpModal(true);
    } catch (error: unknown) {
      if (!displayDuplicateClientError(error)) displayErrorDetails(error);
    } finally {
      isSigningUpRef.current = false;
      setSafeLoading(false);
    }
  };

  const onSubmit = (): void => {
    setLoading(true);
    try {
      setcompleteProfileModal(true);
    } catch (error: unknown) {
      if (error instanceof Error && error.message.includes('Email already exists')) {
        setError('email', {
          type: 'manual',
          message: 'Email already exists, please login to your account',
        });
      } else {
        displayErrorDetails(error);
      }
    }
    setLoading(false);
  };

  const handleOnChangeConfirm = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    clearErrors('confirmPassword');
    setValue('confirmPassword', value);
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    clearErrors('password');
    const { value } = e.target;
    setValue('password', value);

    const capsLetterCheck = hasCapsLetter(value);
    const numberCheck = hasNumber(value);
    const specialFlag = hasSpecialChar(value);
    const pwdLengthCheck = value.length >= 8;

    setChecks({
      capsLetterCheck,
      numberCheck,
      pwdLengthCheck,
      specialFlag,
    });

    setPasswordStr(value);
  };

  // Persist role-specific extras that /auth/signup can't accept. Runs after
  // login (token available) and before navigation. A failure here surfaces an
  // error but does not block dashboard entry — the user can finish in my-profile.
  const persistRoleExtras = async (loginResponse: LoginResponse): Promise<void> => {
    const extras = roleExtrasRef.current;
    if (!extras) return;
    try {
      if (loginResponse.access_token) {
        Cookies.set('jwtToken', loginResponse.access_token, cookieOptions());
      }
      const me = await getCurrentProfile(loginResponse.role);
      if (extras.role === UserRoleName.Provider) {
        const payload: ProviderProfile = {
          education: extras.education,
          specialty: extras.specialty,
          additional_credentials: extras.additional_credentials,
          biography: extras.biography,
        };
        if (me.provider_profile) {
          await saveProviderProfile(payload, me.id);
        } else {
          await createProviderProfile(payload, me.id);
        }
      } else if (extras.role === UserRoleName.CareAdvisor) {
        await saveCareAdvisorProfile({ biography: extras.biography }, me.id, me.role.name);
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      roleExtrasRef.current = null;
    }
  };

  const onConfirmedOTP = async (): Promise<void> => {
    try {
      const loginResponse = await login({
        email: email.email?.toLowerCase() || (phoneNumber as any).phoneNumber || '',
        password: passwordStr,
        organization_id: config.organization_id,
        ...(config.division_id && { division_id: config.division_id }),
        ...(config.practice_id && { practice_id: config.practice_id }),
        ...(client && { client }),
        ...(enteredD1Code && { access_code: enteredD1Code }),
      });

      await persistRoleExtras(loginResponse);

      await triggerPostAuth(loginResponse, {
        event: 'sign_up',
        preloadPricingForPatient: true,
        suspendNavigationIfInvite: true,
        onInviteResult: (payload) => {
          if (payload.status === 'JOINED') {
            sessionStorage.removeItem('authSuspend');
            sessionStorage.removeItem('inviteResult');
            showJoinedToast();
            return;
          }
          setInviteResult(payload);
          sessionStorage.setItem('authSuspend', '1');
          sessionStorage.setItem('inviteResult', JSON.stringify(payload));
        },
      });

      if (mountedRef.current) setOtpModal(false);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const isAllFieldsFilled = useMemo(() => {
    return (
      !watchPassword ||
      !watchConfirm ||
      !checks.capsLetterCheck ||
      !checks.numberCheck ||
      !checks.pwdLengthCheck ||
      !checks.specialFlag ||
      watchPassword !== watchConfirm
    );
  }, [watchPassword, watchConfirm, checks]);

  useEffect(() => {
    const { password, confirmPassword } = getValues();
    if (password && confirmPassword && password !== confirmPassword) {
      setError('confirmPassword', {
        type: 'manual',
        message: "Passwords don't match",
      });
    }
    if (password && confirmPassword && password === confirmPassword) {
      clearErrors('confirmPassword');
    }
  }, [watchPassword, watchConfirm]);

  useEffect(() => {
    if (errors.email && errors.email.message === 'This email already exists') {
      const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
      const clientParam = params.get('client');
      const clientAccessCode = enteredD1Code;
      const currentEmail = getValues('email') as string;

      if (currentEmail) {
        const url = clientParam
          ? `/existing-account?client=${clientParam}&email=${encodeURIComponent(currentEmail)}${
              clientAccessCode ? `&client_access_code=${clientAccessCode}` : ''
            }`
          : `/existing-account?email=${encodeURIComponent(currentEmail)}${
              clientAccessCode ? `&client_access_code=${clientAccessCode}` : ''
            }`;

        navigate(url);
      }
    }
  }, [errors.email, enteredD1Code, getValues, navigate]);

  if (otpModal && email.email) {
    return <ConfirmOTP username={email.email.toLowerCase()} onConfirmed={onConfirmedOTP} />;
  }

  if (completeProfileModal && email.email) {
    return <CompleteProfile signUp={signUp} invitedUser={invitedUser} />;
  }

  if (forgotPasswordStep) {
    return renderForgotPasswordModal();
  }

  const closeInviteModal = (): void => {
    hardSignOut();
    setInviteResult(null);
    sessionStorage.removeItem('authSuspend');
    sessionStorage.removeItem('inviteResult');
    navigate(clientCode ? `/${clientCode}` : '/');
  };

  const backToDashboard = (): void => {
    try {
      localStorage.setItem('isAuthenticated', JSON.stringify({ isAuthenticated: true }));
    } catch {
      /* noop */
    }
    sessionStorage.removeItem('authSuspend');
    sessionStorage.removeItem('inviteResult');
    navigate('/Patient/dashboard');
    setInviteResult(null);
  };

  const goToMyPlan = (): void => {
    try {
      localStorage.setItem('isAuthenticated', JSON.stringify({ isAuthenticated: true }));
    } catch {
      /* noop */
    }
    sessionStorage.removeItem('authSuspend');
    sessionStorage.removeItem('inviteResult');
    navigate(PLAN_ROUTE);
    setInviteResult(null);
  };

  const renderInviteModal = (): JSX.Element | null => {
    if (!inviteResult) return null;

    const isHasPlan = inviteResult.status === 'HAS_PLAN' || inviteResult.status === 'OWNER_CANNOT_JOIN';
    const invalid = inviteResult.status === 'INVALID_TOKEN';

    const title = isHasPlan
      ? 'It looks like you’re already in a plan'
      : invalid
      ? 'Invite link invalid'
      : 'Invite not available';

    const body = isHasPlan
      ? 'At this time, it’s only possible to be in one plan — so you’ll stay with your current plan.'
      : invalid
      ? 'This invite link is invalid or expired. Please contact the person who shared the link with you for assistance.'
      : 'Looks like this plan already has the maximum number of members. If you still need access, we recommend contacting the person who shared the link with you.';

    return (
      <div
        role="dialog"
        aria-modal="true"
        style={backdropStyle}
        onClick={closeInviteModal}
        onKeyDown={(e) => e.key === 'Escape' && closeInviteModal()}
        tabIndex={-1}
      >
        <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <button type="button" aria-label="Close" onClick={closeInviteModal} style={closeBtnStyle}>
            ×
          </button>

          <div style={titleStyle}>{title}</div>
          <div style={descStyle}>{body}</div>

          {isHasPlan ? (
            <>
              <button type="button" onClick={goToMyPlan} style={primaryBtnStyle}>
                Go to My Plan
              </button>
              <button type="button" onClick={closeInviteModal} style={linkBtnStyle}>
                Cancel
              </button>
            </>
          ) : (
            <button type="button" onClick={backToDashboard} style={primaryBtnStyle}>
              Back to Dashboard
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {renderInviteModal()}
      <Sidenav isVisibleOnMobile hideDefaultOptions authLoog />
      <div className={styles.body}>
        <div className={styles.leftSection}>
          <div className={styles.container}>
            <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
              <span className={styles.formTitle}>
                <span className={`${styles.formTitleWelcome} fs-unmask`} data-testid="signup-create-account">
                  {!invitedUser ? 'Get Started' : 'Set Your Password'}
                </span>

                <div className={`${styles.formTitleLink} fs-unmask`} data-testid="signup-title">
                  {errors.email && errors.email.message === 'This email already exists' ? (
                    <div className={styles.existEmail}>
                      <span>That Dentistry.One account already exists.</span>
                      <span>
                        <a onClick={() => navigate(clientCode ? `/${clientCode}` : '/')}>Sign in</a> or{' '}
                        <a onClick={() => setForgotPasswordStep(1)}>reset your password.</a>
                      </span>
                    </div>
                  ) : (
                    <>
                      <span className={styles.txt1}>Already have an account?</span>
                      <a
                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                        className={`txt2 ${styles.txt2}`}
                        onClick={() => {
                          const searchParams = new URLSearchParams(window.location.search);

                          const invite = searchParams.get('invite');
                          const startCase = searchParams.get('start_case');

                          const params = new URLSearchParams();

                          if (invite) params.set('invite', invite);
                          if (startCase) params.set('start_case', startCase);

                          const signInPath = clientCode ? `/${clientCode}` : '/';
                          navigate(`${signInPath}${params.toString() ? `?${params.toString()}` : ''}`);
                        }}
                      >
                        &nbsp;Log in
                      </a>
                    </>
                  )}
                </div>
              </span>

              {!invitedUser && !defaultUser ? (
                <div className={styles.inputWrap}>
                  <TextField
                    {...register('email')}
                    data-testid="signup-email"
                    label="Email"
                    errors={errors.email && errors.email.message !== 'This email already exists' ? errors : {}}
                    name="email"
                    onChange={(e) => {
                      if (errors.email) clearErrors('email');
                      setValue('email', e.target.value);
                    }}
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                  />
                </div>
              ) : (
                <div className={styles.inputWrap}>
                  <TextField
                    {...register('email')}
                    data-testid="signup-email"
                    label=""
                    value={invitedUser?.email || defaultUser?.email}
                    errors={errors.email ? errors : {}}
                    name="email"
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                    disabled
                  />
                </div>
              )}

              <div className={styles.inputWrap}>
                <div className={styles.inputWrapper}>
                  <TextField
                    {...register('password')}
                    data-testid="signup-password"
                    label="Password"
                    type="password"
                    showPasswordToggle
                    name="password"
                    onChange={handleOnChange}
                    autoComplete="new-password"
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                  />
                </div>
              </div>

              <div style={{ marginTop: '-20px' }}>
                <PWDRequisite
                  capsLetterFlag={checks.capsLetterCheck ? 'valid' : 'invalid'}
                  numberFlag={checks.numberCheck ? 'valid' : 'invalid'}
                  pwdLengthFlag={checks.pwdLengthCheck ? 'valid' : 'invalid'}
                  specialFlag={checks.specialFlag ? 'valid' : 'invalid'}
                />
              </div>

              <div className={styles.inputWrap}>
                <div className={styles.inputWrapper} data-validate="Enter password">
                  <TextField
                    {...register('confirmPassword')}
                    data-testid="signup-confirm-password"
                    errors={errors.confirmPassword ? errors : {}}
                    name="confirmPassword"
                    type="password"
                    showPasswordToggle
                    onChange={handleOnChangeConfirm}
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                    label="Confirm password"
                  />
                </div>
              </div>

              <Button
                type="submit"
                style={{ borderRadius: '32px', height: '56px', pointerEvents: loading ? 'none' : undefined }}
                disabled={loading || isAllFieldsFilled}
                auth
                className={`fs-unmask ${styles.formBtn}`}
                data-testid="signup-get-started"
              >
                {!invitedUser ? 'Get Started' : 'Save'}
              </Button>

              <p className={`${styles.termsNotice} fs-unmask`}>
                By signing up, I agree to the{' '}
                <a href="/terms-of-service" target="_blank" rel="noreferrer">
                  terms of service
                </a>
                , the{' '}
                <a href="/privacy-policy" target="_blank" rel="noreferrer">
                  privacy policy
                </a>{' '}
                and if I am a Washington state resident I agree with the{' '}
                <a href="/washington_my_health_my_data_privacy_notice" target="_blank" rel="noreferrer">
                  Washington My Health My Data Privacy Notice
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.25)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalStyle: React.CSSProperties = {
  width: 480,
  maxWidth: '90vw',
  background: '#fff',
  borderRadius: 8,
  padding: '32px 28px 28px',
  position: 'relative',
  boxShadow:
    '0px 22px 40px rgba(16, 24, 40, 0.18), 0px 8px 16px rgba(16, 24, 40, 0.12), 0px 2px 6px rgba(16, 24, 40, 0.08)',
  textAlign: 'center',
};

const closeBtnStyle: React.CSSProperties = {
  position: 'absolute',
  top: 12,
  right: 12,
  width: 32,
  height: 32,
  borderRadius: 16,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  fontSize: 22,
  lineHeight: '22px',
};

const titleStyle: React.CSSProperties = {
  fontSize: 20,
  fontWeight: 700,
  color: '#101828',
  marginBottom: 8,
};

const descStyle: React.CSSProperties = {
  fontSize: 14,
  color: '#475467',
  marginBottom: 20,
  lineHeight: '20px',
};

const primaryBtnStyle: React.CSSProperties = {
  width: '100%',
  height: 44,
  borderRadius: 999,
  border: 'none',
  background: '#10A4E8',
  color: '#fff',
  fontWeight: 600,
  cursor: 'pointer',
  marginTop: 6,
};

const linkBtnStyle: React.CSSProperties = {
  width: '100%',
  height: 44,
  borderRadius: 999,
  border: 'none',
  background: 'transparent',
  color: '#10A4E8',
  fontWeight: 600,
  cursor: 'pointer',
  marginTop: 8,
  textDecoration: 'none',
};
